import { withFormik } from 'formik';
import { newUser } from '../../../facades/eagle/user';
import reduce from 'lodash/reduce';
import { localiseUrl } from 'src/common/utils/format-localised-url';

/* eslint-disable no-console */
const withSignup = withFormik({
  mapPropsToValues: () => ({
    base: '',
    email: '',
    firstname: '',
    lastname: '',
    marketing_opt_in: false,
  }),
  handleSubmit: (values, actions) => {
    const props = actions.props;
    newUser(values)
      .then((response) => {
        const id = response.body.data.id;
        window.location = localiseUrl(props.country, `/resend-email/${id}?email=${values.email}`);
      })
      .catch(err => {
        actions.setSubmitting(false);
        const errors = err.details.errors;
        switch (err.status) {
          case 400:
            const fieldErrors = reduce(errors[0].detail, (result, value, key) => {
              result[key] = value[0];
              return result;
            }, {});
            actions.setErrors(fieldErrors);
            break;
          case 409:
            window.location = localiseUrl(props.country, '/signup/existing-user');
            break;
        }
      });
  },
});
/* eslint-enable no-console */

export default withSignup;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withNewUser.js